import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Breadcrumb } from 'react-bootstrap';
import type { ReactNode } from 'react';

type BreadcrumbChild = {
  href?: string;
  text?: ReactNode;
};

type ToolsBreadcrumbProps = {
  parentName: ReactNode;
  parentUrl?: string;
  childs?: BreadcrumbChild[];
};

const ToolsBreadcrumb = ({
  parentName,
  parentUrl,
  childs
}: ToolsBreadcrumbProps) => {
  return (
    <div className="my-3 fs--2">
      <Breadcrumb className="text-primary">
        <Breadcrumb.Item href="https://mizfa.tools">
          <FontAwesomeIcon icon="home" />
        </Breadcrumb.Item>
        <Breadcrumb.Item href="/">پیشخوان</Breadcrumb.Item>
        <Breadcrumb.Item href={parentUrl}>{parentName}</Breadcrumb.Item>
        {childs?.map((b, i) => (
          <Breadcrumb.Item
            active={childs.length === i + 1}
            key={i}
            href={b?.href}
          >
            {b?.text}
          </Breadcrumb.Item>
        ))}
      </Breadcrumb>
    </div>
  );
};

export default ToolsBreadcrumb;
